var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUOhrRcwe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6594 9.85677C25.8386 8.72401 25.7906 7.52232 25.5102 6.2695C25.0395 4.16364 23.4975 2.49205 21.3858 1.79785C19.2115 1.08225 16.8669 1.52178 15.1158 2.9719C14.6732 3.33886 14.286 3.75637 13.9406 4.1348C13.5952 3.75637 13.2083 3.33855 12.7651 2.9719C11.014 1.52178 8.67095 1.08287 6.49546 1.79785C4.38371 2.49205 2.84204 4.16364 2.37106 6.2695C2.09562 7.50032 2.04449 8.68165 2.21264 9.79689",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20068 15.0691C5.37763 15.2355 5.55518 15.4013 5.73327 15.5665L8.93611 18.4516C9.57661 19.0161 10.2197 19.5785 10.8634 20.1408C11.7043 20.8763 12.5456 21.6127 13.3827 22.355C13.3916 22.3655 13.398 22.3776 13.4075 22.3875C13.5474 22.537 13.7399 22.613 13.9327 22.613C13.9355 22.613 13.9381 22.6124 13.941 22.6124C13.9438 22.6124 13.9467 22.613 13.9496 22.613C14.1424 22.613 14.3345 22.537 14.4747 22.3875C14.4843 22.3776 14.4907 22.3655 14.4993 22.355C15.3345 21.6142 16.1741 20.88 17.0125 20.1467C18.9366 18.4644 20.9243 16.7267 22.8161 14.9424",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2764 4.51611C20.9618 4.51611 22.3279 5.84589 22.3279 7.48678C22.3279 7.89684 22.2425 8.28737 22.0882 8.64315",
    stroke: "#EE3D85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.3537H9.88829L11.5475 7.71289L13.6507 15.7129L16.1981 9.49936L17.4137 12.3537H27",
    stroke: "#22BF76",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUOhrRcwe);
export default __webpack_public_path__ + "static/media/uOHRRcwe.ac9ff8d220b5f9f460ec1b72a1dd5dfd.svg";
export { ForwardRef as ReactComponent };